// eslint-disable-next-line import/no-unresolved
import keenSlider from 'https://cdn.skypack.dev/keen-slider@5.5.1'

class StrapfinderStrapCarousel extends HTMLElement {
  constructor() {
    super()

    this.slidesEl = this.querySelector('[data-el="strapfinder-strap-carousel.slides"]')
    this.slideEls = this.querySelectorAll('[data-el="strapfinder-strap-carousel.slide"]')
    this.watchEls = this.querySelectorAll('[data-el="strapfinder-strap-carousel.watch"]')

    this.dotEls = this.querySelectorAll('[data-el="strapfinder-strap-carousel.dot"]')

    this.controlPrevEl = this.querySelector(
      '[data-el="strapfinder-strap-carousel.controlprevious"]'
    )
    this.controlNextEl = this.querySelector(
      '[data-el="strapfinder-strap-carousel.controlnext"]'
    )
    this.scrollerEl = this.querySelector('[data-el="strapfinder-strap-carousel.scroller"]')

    if (this.slideEls.length < 1) return

    this.carousel = this.initialiseCarousel()

    if (this.moveToSlide) {
      this.carousel.moveToSlide(this.moveToSlide)
    }

    this.controlPrevEl.addEventListener('click', this.onNavClick.bind(this))

    this.controlNextEl.addEventListener('click', this.onNavClick.bind(this))
  }

  initialiseCarousel() {
    // eslint-disable-next-line new-cap
    return new keenSlider(this.slidesEl, {
      slides: '.car-Carousel_Slide',
      slidesPerView: 1,
      spacing: 20,
      rubberband: false,
      snap: true,
      loop: false,
      breakpoints: {
        '(min-width: 768px)': {
          spacing: 50,
        }
      },
      created: instance => {
        this.slidesEl.classList.remove('car-Carousel_Slides-hidden')

        this.dotEls.forEach(dot => {
          dot.addEventListener('click', () => {
            instance.moveToSlide(dot.dataset.slide)
          })
        })

      },
      slideChanged: instance => {
        const maxClicks =
          instance.details().size - instance.details().slidesPerView

        instance.details().relativeSlide === 0
          ? (this.controlPrevEl.disabled = true)
          : (this.controlPrevEl.disabled = false)
        instance.details().relativeSlide >= maxClicks
          ? (this.controlNextEl.disabled = true)
          : (this.controlNextEl.disabled = false)

        this.slideEls.forEach(slideEl => slideEl.setAttribute('aria-current', instance.details().relativeSlide.toString() === slideEl.dataset.index.toString()))
        this.watchEls.forEach(watchEl => watchEl.setAttribute('aria-current', instance.details().relativeSlide.toString() === watchEl.dataset.index.toString()))
      },
      move: instance => {
        if (this.scrollerEl) {
          let progressTrack = instance.details().progressTrack
          progressTrack = progressTrack >= 1 ? 0 : progressTrack
          const movementPercentage = progressTrack * 100
          this.scrollerEl.style.setProperty(
            '--movement',
            `${movementPercentage}%`
          )
        }
      },
    })
  }

  onNavClick(event) {
    if (event.currentTarget.dataset.direction === 'previous') {
      this.carousel.prev()
    } else {
      this.carousel.next()
    }
  }

  get moveToSlide() {
    return this.dataset.moveToSlide ? this.dataset.moveToSlide : null
  }

}

customElements.define('strapfinder-strap-carousel', StrapfinderStrapCarousel)
